import { render, staticRenderFns } from "./HealthTag.vue?vue&type=template&id=2f0ac652"
import script from "./HealthTag.vue?vue&type=script&lang=js"
export * from "./HealthTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports